// Tableaux éditoriaux sur mobile (< 734 px, point de rupture Apple) : chaque
// ligne devient un bloc empilé — 1re cellule en titre, les suivantes précédées
// de leur en-tête (attribut data-label) — au lieu de colonnes écrasées.
// Desktop inchangé : tout est confiné à la media query.
export const stackedTableCss = sel => `
  @media (max-width:733.98px){
    ${sel}, ${sel} tbody, ${sel} tr, ${sel} td { display:block; width:auto; }
    ${sel} { min-width:0 !important; }
    ${sel} thead { position:absolute; width:1px; height:1px; overflow:hidden; clip:rect(0 0 0 0); clip-path:inset(50%); white-space:nowrap; }
    ${sel} tr { padding:16px 18px; border-bottom:1px solid rgba(0,0,0,0.08); }
    ${sel} tr:last-child { border-bottom:none; }
    ${sel} td { padding:0; border:none; min-width:0 !important; overflow-wrap:normal; word-break:normal; }
    ${sel} tr:hover td { background:none; }
    ${sel} td:first-child { font-size:17px; letter-spacing:-0.02em; line-height:1.3; }
    ${sel} td + td { margin-top:10px; line-height:1.5; }
    ${sel} td[data-label]::before { content:attr(data-label); display:block; font-size:11px; font-weight:600; letter-spacing:0.08em; text-transform:uppercase; color:#6e6e73; margin-bottom:2px; }
  }
`

// Montants insécables : « 1 600 à 4 600 € / nuit » ne se coupe jamais, ni
// entre les chiffres, ni avant l'unité, ni au milieu d'une fourchette.
export const nbspAmounts = s => {
  if (typeof s !== "string") return s
  return s
    .replace(/(\d) (?=\d{3}(?!\d))/g, "$1 ")
    .replace(/(\d) (€|%|m²|\$|USD|EUR)/g, "$1 $2")
    .replace(/(\d|€|%) (à|to|–|-) (?=(?:€|\$)?\d)/g, "$1 $2 ")
    .replace(/(Dès|From|dès|from) (?=(?:€|\$)?\d)/g, "$1 ")
    .replace(/(\d|€|\$) \/ (nuit|night)/g, "$1 / $2")
}
